<template>
    <h1>Política de privacidad y uso legal</h1>
</template>